var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "btn-group" }, [
    _vm.canApprove && !_vm.isApproved
      ? _c(
          "button",
          { staticClass: "btn btn-purple btn-sm", on: { click: _vm.approve } },
          [
            _c(
              "el-tooltip",
              {
                attrs: {
                  content: "Start approving",
                  placement: "top",
                  effect: "light",
                },
              },
              [_c("i", { staticClass: "fas fa-file-import" })]
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.canDelete && !_vm.isApproved
      ? _c(
          "button",
          {
            staticClass: "btn btn-danger btn-sm",
            on: { click: _vm.confirmDeleting },
          },
          [
            _c(
              "el-tooltip",
              {
                attrs: { content: "Delete", placement: "top", effect: "light" },
              },
              [_c("i", { staticClass: "fas fa-trash-alt" })]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }